import { render, staticRenderFns } from "./EatenModal.vue?vue&type=template&id=27baad27&scoped=true&"
import script from "./EatenModal.vue?vue&type=script&lang=js&"
export * from "./EatenModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27baad27",
  null
  
)

export default component.exports